import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaBoxes,
  FaCapsules,
  FaHistory,
  FaFilePrescription,
  FaShoppingCart,
} from "react-icons/fa";

// Import the new components
import ActiveMedicationsList from "../components/medications/ActiveMedicationsList";
import MedicationAdministration from "../components/medications/MedicationAdministration";
import MedicationInventoryManager from "../components/medications/MedicationInventoryManager";
import PrescriptionManager from "../components/medications/PrescriptionManager";

const MedicationsPage = () => {
  const location = useLocation();

  // Determine activeSubPage based on pathname
  let activeSubPage;
  if (location.pathname.startsWith("/medications/active")) {
    activeSubPage = "active";
  } else if (location.pathname.startsWith("/medications/prescriptions")) {
    activeSubPage = "prescriptions";
  } else if (location.pathname.startsWith("/medications/ordering")) {
    activeSubPage = "ordering";
  } else if (location.pathname.startsWith("/medications/inventory")) {
    activeSubPage = "inventory";
  } else {
    activeSubPage = "management"; // Default for /medications and /medications/management
  }

  const navLinkClasses =
    "flex-1 flex items-center justify-center px-4 py-3 text-sm font-medium rounded-t-lg transition-colors duration-200 sm:w-auto";
  const activeLinkClasses =
    "text-green-600 bg-white border-b-2 border-green-600";
  const inactiveLinkClasses =
    "text-gray-500 hover:text-gray-700 hover:bg-gray-100";

  return (
    <div className="container mx-auto p-4 md:p-6">
      <h1 className="text-4xl font-bold text-green-700 mb-6">
        Medicine Tracker
      </h1>

      <div className="flex flex-wrap sm:flex-nowrap border-b border-gray-200 mb-6">
        <NavLink
          to="/medications/management"
          className={`${navLinkClasses} ${activeSubPage === "management" ? activeLinkClasses : inactiveLinkClasses}`}
        >
          <FaHistory className="mr-2" /> Dose Log
        </NavLink>
        <NavLink
          to="/medications/active"
          className={`${navLinkClasses} ${activeSubPage === "active" ? activeLinkClasses : inactiveLinkClasses}`}
        >
          <FaCapsules className="mr-2" /> Medicines
        </NavLink>
        <NavLink
          to="/medications/prescriptions"
          className={`${navLinkClasses} ${activeSubPage === "prescriptions" ? activeLinkClasses : inactiveLinkClasses}`}
        >
          <FaFilePrescription className="mr-2" /> Prescriptions
        </NavLink>
        <NavLink
          to="/medications/inventory"
          className={`${navLinkClasses} ${activeSubPage === "inventory" ? activeLinkClasses : inactiveLinkClasses}`}
        >
          <FaBoxes className="mr-2" /> Medicine Cabinet
        </NavLink>
        <NavLink
          to="/medications/ordering"
          className={`${navLinkClasses} ${activeSubPage === "ordering" ? activeLinkClasses : inactiveLinkClasses}`}
        >
          <FaShoppingCart className="mr-2" /> Shopping List
        </NavLink>
      </div>

      <div className="relative bg-white p-6 rounded-lg shadow-lg border-l-4 border-green-500">
        {activeSubPage === "active" && <ActiveMedicationsList />}
        {activeSubPage === "management" && <MedicationAdministration />}
        {activeSubPage === "prescriptions" && <PrescriptionManager />}
        {activeSubPage === "ordering" && (
          <MedicationInventoryManager view="ordering" />
        )}
        {activeSubPage === "inventory" && (
          <MedicationInventoryManager view="inventory" />
        )}
      </div>
    </div>
  );
};

export default MedicationsPage;
